import Link from 'next/link';
import { LinkProps } from 'next/link';
import { styled } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

interface IScPlayButtonProps extends LinkProps {
  href: string;
  size?: number;
}

export const ScPlayButton = styled(Link)<IScPlayButtonProps>`
  display: flex;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border-radius: 360px;
  background-color: ${({ theme }) => theme.mainColor};
  cursor: pointer;
  transition:
    scale 0.5s ease-out,
    box-shadow 0.5s ease-out,
    background-color 0.5s ease-out;

  @media (hover: hover) {
    &:hover {
      scale: 1.1;
      box-shadow: ${({ theme }) =>
        `0px 0px 0px 10px ${hexToRGB(theme.mainColor, 0.1)}, 0px 0px 0px 5px ${hexToRGB(theme.mainColor, 0.3)}`};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.mainColorActive};
    scale: 1;
  }
`;
